export default __webpack_public_path__ + "static/media/M2notification.6a4fa8c3.png";